<div class="modal-header">
    <h5 class="modal-title">New Multi-Year Agreement</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss();"></button>
</div>
<div class="modal-body">
    <form [formGroup]="nextMyaProjectForm">
        <!-- Project Section -->
        <div class="card border-0 p-0 mb-4 mt-1">
          <h5 class="card-title">Project Section</h5>
            <div class="mb-3">
              <label for="MYA_PROJECT_YEAR">Year (YYYY)</label>
              <input id="MYA_PROJECT_YEAR" type="number" class="form-control" placeholder="202x" formControlName="year" required [class.is-invalid]="year.invalid && (year.dirty || year.touched)">
              <div *ngIf="year.invalid && (year.dirty || year.touched)">
                  <div *ngIf="year.errors.required" class="input-validation-msg">Year is required.</div>
              </div>
            </div>
            <div>
                <label for="MYA_PROJECT_TITLE">Title</label>
                <input id="MYA_PROJECT_TITLE" type="text" class="form-control" placeholder="Mya Project 202x" formControlName="title" required [class.is-invalid]="title.invalid && (title.dirty || title.touched)">
                <div *ngIf="title.invalid && (title.dirty || title.touched)">
                    <div *ngIf="title.errors.required" class="input-validation-msg">Title is required.</div>
                </div>
            </div>
        </div>
        <!-- Proposal Section -->
        <div class="card border-0 p-0 mb-4">
          <h5 class="card-title">Proposal Section</h5>
          <label>Auto-Accept Proposal</label>
            <div>
                <div class="form-check form-check-inline">
                    <input id="AUTO_ACCEPT_PROPOSAL_YES" class="form-check-input" type="radio" formControlName="autoAcceptProposal" [value]="true">
                    <label for="AUTO_ACCEPT_PROPOSAL_YES" class="form-check-label" style="font-weight: normal;">Yes</label>
                </div>
                <div class="form-check form-check-inline">
                    <input id="AUTO_ACCEPT_PROPOSAL_NO" class="form-check-input" type="radio" formControlName="autoAcceptProposal" [value]="false">
                    <label for="AUTO_ACCEPT_PROPOSAL_NO" class="form-check-label" style="font-weight: normal;">No</label>
                </div>
            </div>
        </div>
        <!-- Invoice Section -->
        <div class="card border-0 p-0" *ngIf="autoAcceptProposal.value">
          <h5 class="card-title">Invoice Section</h5>
          <label>Auto-Generate Invoice</label>
            <div class="mb-3">
                <div class="form-check form-check-inline">
                    <input id="AUTO_GENERATE_INVOICE_YES" class="form-check-input" type="radio" formControlName="autoGeneratingInvoice" [value]="true">
                    <label for="AUTO_GENERATE_INVOICE_YES" class="form-check-label" style="font-weight: normal;">Yes</label>
                </div>
                <div class="form-check form-check-inline">
                    <input id="AUTO_GENERATE_INVOICE_NO" class="form-check-input" type="radio" formControlName="autoGeneratingInvoice" [value]="false">
                    <label for="AUTO_GENERATE_INVOICE_NO" class="form-check-label" style="font-weight: normal;">No</label>
                </div>
            </div>
            <div class="mb-3" *ngIf="autoGeneratingInvoice.value">
               <label for="INVOICE_AMOUNT">Amount</label>
                <div class="input-group">
                  <button *ngIf="amountType == 'DOLLAR'" type="button" class="btn btn-outline-secondary"
                    (click)="amountType = 'PERCENT';">$</button>
                  <input id="INVOICE_AMOUNT" class="form-control" type="number" formControlName="amount" placeholder="0" min="1"
                    [max]="amountType == 'PERCENT' ? 100 : null" required
                    [class.is-invalid]="autoGeneratingInvoice.value && amount.invalid && (amount.dirty || amount.touched)">
                  <button *ngIf="amountType == 'PERCENT'" type="button" class="btn btn-outline-secondary"
                    (click)="amountType = 'DOLLAR';">%</button>
                </div>
                <div *ngIf="autoGeneratingInvoice.value && amount.invalid && (amount.dirty || amount.touched)">
                  <div *ngIf="autoGeneratingInvoice.value && amount.errors.required" class="input-validation-msg">Amount is required.</div>
                  <div *ngIf="autoGeneratingInvoice.value && amount.errors.min" class="input-validation-msg">Amount cannot be equal to or less than 0.</div>
                  <div *ngIf="autoGeneratingInvoice.value && amountType == 'PERCENT' && amount.errors.max" class="input-validation-msg">Amount cannot be more than 100%.</div>
                </div>
            </div>
            <div class="mb-3" *ngIf="autoGeneratingInvoice.value">
              <label for="INVOICE_ISSUE_DATE">Issue Date</label>
                <div class="input-group">
                  <input id="INVOICE_ISSUE_DATE" class="form-control" formControlName="issueDate" placeholder="YYYY-MM-DD" required ngbDatepicker #issueDatepicker="ngbDatepicker" placement="left" [positionTarget]="issueDatepickerBtn" [class.is-invalid]="autoGeneratingInvoice.value && issueDate.invalid && (issueDate.dirty || issueDate.touched)">
                  <button #issueDatepickerBtn type="button" class="btn btn-outline-primary" (click)="issueDatepicker.toggle();">
                    <fa-icon [icon]="faCalendar"></fa-icon>
                  </button>
                </div>
                <div *ngIf="autoGeneratingInvoice.value && issueDate.invalid && (issueDate.dirty || issueDate.touched)">
                  <div *ngIf="autoGeneratingInvoice.value && issueDate.errors.required" class="input-validation-msg">Issue Date is required.</div>
                </div>
            </div>
            <div class="mb-3" *ngIf="autoGeneratingInvoice.value">
              <label for="INVOICE_DUE_DATE">Due Date</label>
                <div class="input-group">
                  <input id="INVOICE_DUE_DATE" class="form-control" formControlName="dueDate" placeholder="YYYY-MM-DD" required ngbDatepicker #dueDatepicker="ngbDatepicker" placement="left" [positionTarget]="dueDatepickerBtn" [class.is-invalid]="autoGeneratingInvoice.value && dueDate.invalid && (dueDate.dirty || dueDate.touched)">
                  <button #dueDatepickerBtn type="button" class="btn btn-outline-primary" (click)="dueDatepicker.toggle();">
                    <fa-icon [icon]="faCalendar"></fa-icon>
                  </button>
                </div>
                <div *ngIf="autoGeneratingInvoice.value && dueDate.invalid && (dueDate.dirty || dueDate.touched)">
                  <div *ngIf="autoGeneratingInvoice.value && dueDate.errors.required" class="input-validation-msg">Due Date is required.</div>
                </div>
            </div>
            <!-- <label *ngIf="autoGeneratingInvoice.value">Schedule Send Invoice</label>
            <div class="mb-3" *ngIf="autoGeneratingInvoice.value">
                <div class="form-check form-check-inline">
                    <input id="SCHEDULE_SEND_INVOICE_YES" class="form-check-input" type="radio" formControlName="scheduleSendInvoice" [value]="true">
                    <label for="SCHEDULE_SEND_INVOICE_YES" class="form-check-label" style="font-weight: normal;">Yes</label>
                </div>
                <div class="form-check form-check-inline">
                    <input id="SCHEDULE_SEND_INVOICE_NO" class="form-check-input" type="radio" formControlName="scheduleSendInvoice" [value]="false">
                    <label for="SCHEDULE_SEND_INVOICE_NO" class="form-check-label" style="font-weight: normal;">No</label>
                </div>
            </div>
            <div *ngIf="autoGeneratingInvoice.value && scheduleSendInvoice.value">
              <label for="SEND_TIME">Send Time</label>
                  <input
                    id="SEND_TIME"
                    type="time"
                    class="form-control w-25"
                    formControlName="sendTime"
                    step="900"
                  />
                 <small class="text-muted">Invoice will be scheduled to send on the Issue Date as above.</small>
                <div *ngIf="autoGeneratingInvoice.value && scheduleSendInvoice.value && (sendTime.invalid && (sendTime.dirty || sendTime.touched))">
                  <div *ngIf="sendTime.errors.required" class="input-validation-msg">
                    Send Time is required.
                  </div>
                </div>
            </div> -->
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="addNextMyaProject();">Save</button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss();">Close</button>
</div>
